import { useEffect, useState } from "react";
import { BACKEND_URL, makeRequestAuth, uploadFiles } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import NoData from "../../utils/DataNotFound";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import profile from "../../assets/img/profile.jpg";

export default function JobQueries() {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [loading, setLoading] = useState(true);

    const [serviceId, setServiceId] = useState("");
    const [pageNo, setPageNo] = useState(1);
    const pageSize = 10;
    const [totalPages, setTotalPages] = useState(1);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [updatingId, setUpdatingId] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [excelModalOpen, setExcelModalOpen] = useState(false);

    const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
    const [pendingApprovalAgent, setPendingApprovalAgent] = useState(null);
    const [creatingCategory, setCreatingCategory] = useState(false);

    const [agentImage, setAgentImage] = useState("");
    const [uploadingImage, setUploadingImage] = useState(false);

    const [showApproveEditModal, setShowApproveEditModal] = useState(false);
    const [editAgentData, setEditAgentData] = useState(null);


    const fetchJobQueries = async () => {
        try {
            setLoading(true);
            const res = await makeRequestAuth(
                "post",
                "/admin/getSerciveJobsList",
                {
                    pageNo,
                    size: pageSize,
                    search,
                    status,
                    serviceId
                }
            );

            if (res?.error) {
                showErrorToast(res.message || "Failed to fetch job queries");
                setData([]);
                return;
            }

            setData(res?.data?.list || []);
            setTotalPages(Math.ceil((res?.data?.total || 0) / pageSize));
        } catch (err) {
            showErrorToast("Something went wrong");
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchServices = async () => {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/getListServiceCategory",
                {}
            );

            if (!res?.error) {
                setServiceList(res.data?.list || []);
            }
        } catch (err) {
            setServiceList([]);
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => {
        const timer = setTimeout(fetchJobQueries, 200);
        return () => clearTimeout(timer);
    }, [pageNo, search, status, serviceId]);

    const updateStatus = async (id, newStatus, newServiceType = undefined, extraData = {}) => {
    try {
        setUpdatingId(id);
        const payload = { 
            id, 
            status: newStatus,
            ...extraData // 👈 Name, email, image payload mein chala jayega
        };
        if (newServiceType !== undefined) {
            payload.serviceType = newServiceType;
        }
        const res = await makeRequestAuth(
            "post",
            "/admin/updateJobQueryStatus",
            payload
        );

        if (res?.error) {
            return showErrorToast(res.message || "Status update failed");
        }

        showSuccessToast("Status updated");
        fetchJobQueries();
    } catch {
        showErrorToast("Status update error");
    } finally {
        setUpdatingId(null);
    }
};


   const handleStatusChange = (item, newStatus) => {
    if (newStatus === "approved") {
        // Direct status change ke bajaye details ko Edit Modal mein load karein
        setEditAgentData({ ...item });
        setShowApproveEditModal(true);
    } else {
        updateStatus(item._id, newStatus);
    }
};


    const handleCreateCategoryAndApprove = async () => {
        if (!pendingApprovalAgent) return;
        try {
            setCreatingCategory(true);

            // 1. Create the service category
            const resCat = await makeRequestAuth(
                "post",
                "/admin/saveServiceCategory",
                {
                    name: pendingApprovalAgent.customServiceType,
                    image: "https://placehold.co/600x400/png?text=Service+Category", // default placeholder image
                    pricingOptions: []
                }
            );

            if (resCat?.error) {
                showErrorToast(resCat.message || "Failed to create service category");
                setCreatingCategory(false);
                return;
            }

            const newCategoryId = resCat?.data?._id;
            if (!newCategoryId) {
                showErrorToast("Could not retrieve created category ID");
                setCreatingCategory(false);
                return;
            }

            // 2. Approve the agent with newCategoryId
            await updateStatus(pendingApprovalAgent.id, pendingApprovalAgent.status, newCategoryId);

            setShowCreateCategoryModal(false);
            setPendingApprovalAgent(null);

            // Refresh service list
            fetchServices();
        } catch (err) {
            showErrorToast("Something went wrong");
        } finally {
            setCreatingCategory(false);
        }
    };

    const handleExcelDownload = async () => {
        setExcelModalOpen(false);
        const { token } = JSON.parse(sessionStorage.getItem("user")) || {}
        if (!token) return

        if (data.length === 0) {
            showErrorToast(
                "No records found. Try clearing the filters or changing your search, then download again."
            );
            return
        }
        try {
            const res = await axios.post(
                BACKEND_URL + "/admin/exportServicAgentExcel",
                {
                    search,
                    status,
                    serviceId,
                    startDate,
                    endDate,
                },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.data.type === "application/json") {
                const text = await res.data.text();
                const json = JSON.parse(text);

                if (json.error) {
                    return showErrorToast(json.message);
                }
            }

            const fileBlob =
                res instanceof Blob
                    ? res
                    : res?.data instanceof Blob
                        ? res.data
                        : new Blob([res], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });


            const url = window.URL.createObjectURL(fileBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Service_Agent_${Date.now()}_sheet.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            showErrorToast("Excel download failed");
        }
    };


    const prevPage = () => pageNo > 1 && setPageNo((p) => p - 1);
    const nextPage = () => pageNo < totalPages && setPageNo((p) => p + 1);

    const handleFilterMyAgents = () => {
        console.log("My Agent clicked");

        // example: sirf approved agents filter karna ho
        setStatus("approved");

        // ya agar backend me special filter hai
        // setSearch("my-agent"); (example)
    };

    return (
        <div className="p-6 min-h-screen bg-white">
            <ToastContainer />

            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-[#434646]">
                    Service Agent Job Queries
                </h2>

                <button
                    onClick={() => navigate("/services/my-agents")}
                    className="px-4 py-2 rounded-xl border border-[#24ADD7] text-[#24ADD7]
          hover:bg-[#24ADD7] hover:text-white transition"
                >
                    My Agent
                </button>
            </div>

            {/* FILTER BAR – SAME AS LOAN QUERY */}
            <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6 shadow-sm">
                <div className="flex flex-wrap gap-4 items-end">

                    {/* 🔍 SEARCH */}
                    <div className="relative flex-1 min-w-[220px]">
                        <input
                            type="text"
                            placeholder="Search name / phone / email"
                            value={search}
                            onChange={(e) => {
                                setPageNo(1);
                                setSearch(e.target.value);
                            }}
                            className="pl-10 pr-4 py-2 border border-gray-200 rounded-xl w-full
              text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                        />
                        <svg
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                    <select
                        value={status}
                        onChange={(e) => {
                            setPageNo(1);
                            setStatus(e.target.value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm
            text-[#434646] focus:border-[#24ADD7] outline-none"
                    >
                        <option value="">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                    </select>

                    <select
                        value={serviceId}
                        onChange={(e) => {
                            setPageNo(1);
                            setServiceId(e.target.value);
                        }}
                        className="px-4 py-2 rounded-xl border border-gray-200 text-sm
  text-[#434646] focus:border-[#24ADD7] outline-none"
                    >
                        <option value="">All Services</option>

                        {serviceList.map((service) => (
                            <option key={service._id} value={service._id}>
                                {service.name}
                            </option>
                        ))}
                    </select>
                    <button
                        disabled={data.length === 0}
                        onClick={() => setExcelModalOpen(true)}
                        className="px-5 py-2 rounded-xl text-sm font-semibold
  bg-[#24ADD7] text-white hover:bg-orange-600 transition"
                    >
                        ⬇ Download Excel
                    </button>

                    {(search || status || serviceId) && (
                        <button
                            onClick={() => {
                                setSearch("");
                                setStatus("");
                                setServiceId('')
                                setPageNo(1);
                            }}
                            className="px-4 py-2 rounded-xl text-sm font-semibold
              border border-[#24ADD7] text-[#24ADD7]
              hover:bg-[#24ADD7] hover:text-white transition"
                        >
                            Clear All
                        </button>
                    )}
                </div>
            </div>

            {/* LOADING */}
            {/* {loading && (
                <div className="text-center py-20 text-gray-500">
                    Loading job queries...
                </div>
            )} */}

            {/* TABLE – SAME DESIGN */}
            <div className="overflow-x-auto bg-white rounded-2xl shadow-xl border border-gray-100">
                <table className="w-full min-w-[700px]">
                    <thead className="bg-gradient-to-r from-[#24ADD7] to-orange-500">
                        <tr>
                            <th className="p-3 text-left text-white text-sm">#</th>
                            <th className="p-3 text-left text-white text-sm">Profile</th>
                            <th className="p-3 text-left text-white text-sm">Date</th>
                            <th className="p-3 text-left text-white text-sm">Name</th>
                            <th className="p-3 text-left text-white text-sm">Phone</th>
                            <th className="p-3 text-left text-white text-sm">Email</th>
                            <th className="p-3 text-left text-white text-sm">Service</th>
                            <th className="p-3 text-left text-white text-sm">Status</th>
                            <th className="p-3 text-left text-white text-sm">Action</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                        {!loading && data.length > 0 ? (
                            data.map((item, key) => (
                                <tr key={item._id} className="hover:bg-orange-50/50">
                                    <td className="p-3 font-semibold text-[#434646]">
                                        {key + 1 + (pageNo - 1) * pageSize}.
                                    </td>

                                    <td className="p-3">
                                        <img
                                            src={item.image || profile}
                                            alt={item.name || "image"}
                                            className="w-12 h-12 rounded-full object-cover border border-gray-200"
                                        />
                                    </td>

                                    <td className="p-3 text-[#434646] text-sm">
                                        {item.createdAt
                                            ? new Date(item.createdAt).toLocaleDateString()
                                            : "-"}
                                    </td>
                                    <td className="p-3 font-semibold text-[#434646]">
                                        {item.name}
                                    </td>
                                    <td className="p-3 text-[#434646]">{item.phone}</td>
                                    <td className="p-3 text-[#434646]">{item.email}</td>
                                   <td className="p-3 text-[#434646] font-medium">
    {
        (Array.isArray(item?.serviceType) && item.serviceType.length > 0)
            ? item.serviceType.map(s => (typeof s === 'object' ? s?.name : s)).filter(Boolean).join(", ")
            : (item?.serviceType?.name)
            ? item.serviceType.name
            : (Array.isArray(item?.serviceTypeArray) && item.serviceTypeArray.length > 0)
            ? item.serviceTypeArray.join(", ")
            : item?.customServiceType || "-"
    }
</td>


                                    <td className="p-3">
  {/* 🔴 RED COLOR STATUS BADGE FOR DISABLED */}
  <span
    className={`px-3 py-1 rounded-full text-xs font-semibold capitalize ${
      item.status === "approved"
        ? "bg-green-100 text-green-600"
        : item.status === "disabled" || item.status === "rejected"
        ? "bg-red-100 text-red-600 font-bold" // 🔴 Disabled & Rejected = RED
        : "bg-yellow-100 text-yellow-600"
    }`}
  >
    {item.status}
  </span>
</td>

<td className="p-3">
  <select
    value={item.status}
    disabled={updatingId === item._id}
    onChange={(e) => handleStatusChange(item, e.target.value)}
    className="px-3 py-1 rounded-full text-xs font-semibold border border-[#24ADD7]/40 text-[#24ADD7] outline-none cursor-pointer bg-white"
  >
    <option value="pending">Pending</option>
    <option value="approved">Approved</option>
    <option value="rejected">Rejected</option>
    <option value="disabled">Disabled</option>
  </select>
</td>

                                </tr>
                            ))
                        ) : (
                            !loading && (
                                <tr>
                                    <td colSpan={6} className="text-center py-10">
                                        <NoData />
                                    </td>
                                </tr>
                            )
                        )}

                    </tbody>
                </table>
            </div>

            {/* PAGINATION – SAME */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 mt-6 p-3 bg-white rounded-2xl shadow-lg border">
                    <button
                        onClick={prevPage}
                        disabled={pageNo === 1}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        ← Prev
                    </button>

                    <span className="font-semibold text-[#434646]">
                        Page {pageNo} of {totalPages}
                    </span>

                    <button
                        onClick={nextPage}
                        disabled={pageNo === totalPages}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        Next →
                    </button>
                </div>
            )}
            {showCreateCategoryModal && pendingApprovalAgent && (
                <div className="fixed inset-0 bg-black/60 z-[999] flex justify-center items-center backdrop-blur-sm">
                    <div className="bg-[#0B1324] border border-gray-800 text-center p-8 rounded-3xl w-[95%] sm:w-[460px] shadow-2xl scale-100">
                        {/* Warning Icon */}
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-900/30 text-yellow-500 mb-6">
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>

                        <h2 className="text-2xl font-bold text-white mb-3">
                            Category Creation Required
                        </h2>

                        <p className="text-gray-300 text-sm mb-6 px-4 leading-relaxed">
                            The service category <span className="font-bold text-[#24ADD7]">"{pendingApprovalAgent.customServiceType}"</span> does not exist on our platform.
                            <br />
                            <span className="text-xs text-gray-400 mt-2 block">
                                Click "Create to Continue" to automatically register this category and approve the agent.
                            </span>
                        </p>

                        <div className="flex justify-center gap-4">
                            <button
                                disabled={creatingCategory}
                                onClick={() => {
                                    setShowCreateCategoryModal(false);
                                    setPendingApprovalAgent(null);
                                }}
                                className="bg-white/10 text-white hover:bg-white/20 px-6 py-3 rounded-xl min-w-[120px] font-semibold transition disabled:opacity-50"
                            >
                                Cancel
                            </button>

                            <button
                                disabled={creatingCategory}
                                onClick={handleCreateCategoryAndApprove}
                                className="bg-[#24ADD7] hover:bg-[#1a8bb0] text-white px-6 py-3 rounded-xl min-w-[160px] font-semibold shadow-lg shadow-[#24ADD7]/30 transition disabled:opacity-50 flex items-center justify-center gap-2"
                            >
                                {creatingCategory ? (
                                    <>
                                        <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                        Creating...
                                    </>
                                ) : (
                                    "Create to Continue"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
{/* ✏️ EDIT & APPROVE AGENT MODAL */}
{showApproveEditModal && editAgentData && (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-[24px] w-full max-w-[500px] overflow-hidden shadow-2xl border border-gray-100 p-6 space-y-5">
            
            {/* Header */}
            <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                <h3 className="text-lg font-bold text-gray-800">
                    Approve & Edit Agent Details
                </h3>
                <button
                    onClick={() => {
                        setShowApproveEditModal(false);
                        setAgentImage("");
                    }}
                    className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-red-500 hover:text-white transition"
                >
                    ✕
                </button>
            </div>

            {/* Form Fields */}
            <div className="space-y-4 text-xs font-semibold text-gray-600">
                
                {/* Agent Name */}
                <div>
                    <label className="block mb-1 text-gray-400 uppercase">Agent Name</label>
                    <input
                        type="text"
                        value={editAgentData.name || ""}
                        onChange={(e) => setEditAgentData({ ...editAgentData, name: e.target.value })}
                        className="w-full p-2.5 rounded-xl border border-gray-200 focus:outline-none focus:border-[#24ADD7]"
                    />
                </div>

                {/* Phone Number (❌ DISABLED / NON-EDITABLE) */}
                <div>
                    <label className="block mb-1 text-gray-400 uppercase">Phone Number (Read Only)</label>
                    <input
                        type="text"
                        value={editAgentData.phone || ""}
                        disabled
                        readOnly
                        className="w-full p-2.5 rounded-xl border border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed outline-none"
                    />
                </div>

                {/* Email */}
                <div>
                    <label className="block mb-1 text-gray-400 uppercase">Email Address</label>
                    <input
                        type="email"
                        value={editAgentData.email || ""}
                        onChange={(e) => setEditAgentData({ ...editAgentData, email: e.target.value })}
                        className="w-full p-2.5 rounded-xl border border-gray-200 focus:outline-none focus:border-[#24ADD7]"
                    />
                </div>

                {/* Assign Service */}
                <div>
                    <label className="block mb-1 text-gray-400 uppercase">Assign Service</label>
                    <select
                        value={editAgentData.serviceType?._id || editAgentData.serviceType || ""}
                        onChange={(e) => setEditAgentData({ ...editAgentData, serviceType: e.target.value })}
                        className="w-full p-2.5 rounded-xl border border-gray-200 focus:outline-none focus:border-[#24ADD7]"
                    >
                        <option value="">Select Service</option>
                        {serviceList.map((service) => (
                            <option key={service._id} value={service._id}>
                                {service.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* 🖼️ Upload Agent Image (Mandatory field) */}
                <div>
                    <label className="block mb-1 text-gray-400 uppercase">
                        Upload Agent Image <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            try {
                                setUploadingImage(true);
                                const res = await uploadFiles({
                                    fieldName: "file",
                                    files: [file],
                                });
                                if (res?.error) {
                                    return showErrorToast(res.message || "Image upload failed");
                                }
                                setAgentImage(res.data.imageUrl);
                                showSuccessToast("Agent Image Uploaded");
                            } catch (err) {
                                showErrorToast("Upload error");
                            } finally {
                                setUploadingImage(false);
                            }
                        }}
                        className="w-full p-2 rounded-xl border border-gray-200 text-xs focus:outline-none"
                    />
                    
                    {uploadingImage && (
                        <p className="text-[10px] text-blue-500 font-bold mt-1">Uploading Image...</p>
                    )}
                    
                    {agentImage && (
                        <div className="mt-2 flex items-center gap-3 bg-gray-50 p-2 rounded-xl border border-gray-100">
                            <img src={agentImage} alt="Uploaded Agent" className="w-12 h-12 rounded-lg object-cover border" />
                            <span className="text-[11px] text-green-600 font-bold">✓ Image Ready</span>
                        </div>
                    )}
                </div>

            </div>

            {/* Footer Buttons */}
            <div className="flex justify-end gap-3 pt-3 border-t border-gray-100">
                <button
                    onClick={() => {
                        setShowApproveEditModal(false);
                        setAgentImage("");
                    }}
                    className="px-4 py-2 rounded-xl text-gray-500 bg-gray-100 hover:bg-gray-200 text-xs font-semibold"
                >
                    Cancel
                </button>

                {/* 🚫 Approve Button jab tak agentImage nahi aayegi tab tak DISABLE rahega */}
                <button
                    disabled={!agentImage || uploadingImage}
                    onClick={() => {
                        if (!agentImage) {
                            return showErrorToast("Please upload agent image before approving");
                        }

                        const selectedServiceId = typeof editAgentData.serviceType === 'object' 
                            ? editAgentData.serviceType?._id 
                            : editAgentData.serviceType;
                            
                        updateStatus(editAgentData._id, "approved", selectedServiceId,{
                            name: editAgentData.name,
                            email: editAgentData.email,
                            image: agentImage   
                        });
                        setShowApproveEditModal(false);
                        setAgentImage("");
                    }}
                    className={`px-5 py-2 rounded-xl text-white text-xs font-semibold shadow-md transition-all ${
                        !agentImage || uploadingImage
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-green-600 hover:bg-green-700 cursor-pointer"
                    }`}
                >
                    Approve Agent
                </button>
            </div>

        </div>
    </div>
)}



{excelModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
        <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl p-6">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-extrabold text-slate-800">Download Excel</h3>
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">End Date</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
            </div>
            <div className="flex justify-end gap-3 mt-8">
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 hover:bg-gray-50 transition-all"
                >
                    Cancel
                </button>
                <button
                    onClick={handleExcelDownload}
                    className="px-6 py-2.5 bg-[#24ADD7] text-white rounded-xl text-sm font-black hover:bg-[#198cae] transition-all shadow-lg shadow-cyan-100"
                >
                    Download
                </button>
            </div>
        </div>
    </div>
)}

        </div>
            );
}
